export const discardChanges = (user, canReadAdminAddress, intl, userAdministrationModal, modal) => {
  if (userAdministrationModal.hasUnsavedChanges) {
    modal.openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        type: 'error',
        title: intl.formatMessage({
          id: 'unsavedChanges',
        }),
        content: intl.formatMessage({
          id: 'unsavedChangesDescription',
        }),
        confirmLabel: intl.formatMessage({
          id: 'discard',
        }),
        cancelLabel: intl.formatMessage({
          id: 'stay',
        }),
        onConfirm: () => {
          modal.closeModal();
          userAdministrationModal.setHasUnsavedChanges(false);
          userAdministrationModal.setSelectedUser(user);
          userAdministrationModal.setIsAddingUser(false);
          userAdministrationModal.setService('');
          userAdministrationModal.setIsPrimaryResidentAddress(!!canReadAdminAddress);
        },
      },
    });
  } else {
    userAdministrationModal.setSelectedUser(user);
    userAdministrationModal.setIsAddingUser(false);
    userAdministrationModal.setService('');
    userAdministrationModal.setIsPrimaryResidentAddress(!!canReadAdminAddress);
  }
};
